<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="16">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-select v-model="query.updater" placeholder="请选择更新人" filterable clearable @change="handleSearch">
              <el-option
                v-for="item in updaterList"
                :key="item.id"
                :label="item.first_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
              
          <el-col :span="2">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="createShipApply">申请入会</el-button>

            <!-- <span>
              <el-button type="primary" size="small"  @click="handleCustomerUploadCert">上传证书</el-button>
            </span>
            &nbsp;&nbsp;
            <span>
              <el-button type="primary" size="small"  v-if="$perm(['customer.export_customer_info'])" @click="doExport">导出</el-button>
            </span> -->
          </el-col>
          <el-col :span="3">
            <el-button type="primary" size="small"  @click="memberUpdateExport">会员变更申请书</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <!-- 客户名称 -->
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column align="left" label="会员名称" min-width="120px">
              <template slot-scope="scope">
                <span v-if="$perm(['customer.view_customer'])" class="font-weight-bold text-link"
                      @click="handleUpdate(scope.row.id)">{{scope.row.name}}</span>
                <span v-else class="font-weight-bold">{{scope.row.name}}</span>
                <span class="badge ml-2" :class="scope.row.type === '0' ? 'badge-success' : 'badge-warning'">{{ scope.row.type_name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="状态">
              <template slot-scope="scope">
                <span>{{scope.row.status_name}}</span>
              </template>
            </el-table-column>
            <!-- 固定电话 -->
            <!-- <el-table-column align="left" label="电话">
              <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
              </template>
            </el-table-column> -->
            <!-- 手机号码 -->
            <!-- <el-table-column align="left" label="手机">
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column> -->
            <!-- 邮箱 -->
            <el-table-column align="left" label="邮箱">
              <template slot-scope="scope">
                <span>{{scope.row.email}}</span>
              </template>
            </el-table-column>

            <!-- 更新人 -->
            <el-table-column align="left" label="更新人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 创建时间 -->
            <el-table-column align="left" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>
            <!-- 数据完整度 -->
            <el-table-column align = "left" label = "数据完整度">
              <template slot-scope = "scope">
                <span :style="{'color': completeness(scope.row)<30? 'red': completeness(scope.row)>70? 'green':'blue'}"> 
                  <!-- 完成率<30%(红色);完成率>70%(绿色);其他(蓝色) -->
                  {{ completeness(scope.row) }}%
                </span>
              </template>
            </el-table-column>
            <!-- 证书识别状态 -->
            <!-- <el-table-column align="left" label="证书状态">
              <template slot-scope="scope">
                <el-popover :disabled="scope.row.cert_status==='0' || scope.row.cert_status==='1'"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content=scope.row.cert_msg>
                  <span class="badge mr-1" :class="getCertStatusBadge(scope.row.cert_status)" slot="reference">{{ scope.row.cert_status_name }}</span>
                </el-popover>
              </template>
            </el-table-column> -->
            <!-- 按钮组 -->
            <!-- 到期时间 -->
            <el-table-column align="left" label="会员到期时间">
              <template slot-scope="scope">
                <span>{{ scope.row.expire_date | parseTime }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpdate(scope.row.id)">
                    <svg-icon icon-class="edit"></svg-icon>
                  </el-button>
                </el-tooltip>
                <!-- <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                  <el-button v-if="$perm(['customer.delete_customer'])"
                             type="text" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip> -->
                <el-tooltip effect="light" content="资料上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="申请退会" placement="top-start" v-if="scope.row.is_perm == 1">
                    <el-button type="text" class="pr-1" @click="handleQuit(scope.row)">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>      
                <el-tooltip effect="light" content="船舶入会" placement="top-start" v-if="scope.row.is_perm == 1">
                  <el-button type="text" class="pr-1" @click="handleShipApply(scope.row)">
                    <i class="el-icon-connection"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
          <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              object-type="member.member"
              :object-id="apply_id"
              :customer-list="customerList"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
        </div>
      </el-card>
      <member-upload-cert-dialog ref="CustomerUploadCert">
      </member-upload-cert-dialog>
      <el-dialog title="会员信息变更申请书" :visible.sync="memberUpdateVisible" width="800px" top="20px">
      <el-form ref="dataForm" :model="formData"  label-width="120px" class="mx-30">

        <el-form-item label="新会员名称" width="50%">
              <el-input v-model="formData.new_name"></el-input>
            </el-form-item>            
        <el-form-item label="新法人代表" width="50%">
              <el-input v-model="formData.new_legal"></el-input>
        </el-form-item>
        <el-form-item label="新证件编号" width="50%">
              <el-input v-model="formData.new_number"></el-input>
            </el-form-item>            
        <el-form-item label="新联系地址" width="50%">
              <el-input v-model="formData.new_address"></el-input>
        </el-form-item>
        
        <el-form-item label="新联系电话" width="50%">
              <el-input v-model="formData.new_mobile"></el-input>
            </el-form-item>            
        <el-form-item label="新电子邮箱" width="50%">
              <el-input v-model="formData.new_email"></el-input>
          </el-form-item>
        <el-form-item label="授权内容">
                <el-checkbox-group v-model="formData.limits">
                  <el-checkbox label="接收文件/信息"></el-checkbox>
                  <el-checkbox label="参加活动"></el-checkbox>
                  <el-checkbox label="签署文件"></el-checkbox>
                  <el-checkbox label="支付款项"></el-checkbox>
                </el-checkbox-group>
        </el-form-item>
        <el-form-item label="授权期限">
          <el-radio v-model="formData.type" label="1" >有效期至会员资格终止</el-radio>
          <el-radio v-model="formData.type" label="2" >设置有效期</el-radio>
        </el-form-item>
        <el-form-item label="授权年限"  v-if="formData.type === '2'">
                <el-input-number v-model="formData.effect_years"></el-input-number>
        </el-form-item>
        <el-form-item label="操作联系人">
          <el-radio v-model="formData.set_type" label="1" >新增</el-radio>
          <el-radio v-model="formData.set_type" label="2" >减除</el-radio>
          <el-radio v-model="formData.set_type" label="3" >替换</el-radio>
          <el-radio v-model="formData.set_type" label="4" >暂不操作</el-radio>
        </el-form-item>
        <el-form-item label="需要剔除的联系人姓名" v-if="formData.set_type === '2'">
            <el-input v-model="formData.delete_name"></el-input>
          </el-form-item>
          <el-form-item label="需要替换的联系人姓名" v-if="formData.set_type === '3'">
            <el-input v-model="formData.update_name"></el-input>
          </el-form-item>
        <el-form-item label="新联系人姓名" v-if="formData.set_type === '1' | formData.set_type === '3'">
            <el-input v-model="formData.contact.name"></el-input>
          </el-form-item>
          <el-form-item label="性别" v-if="formData.set_type === '1' | formData.set_type === '3'">
            <el-input v-model="formData.contact.sex"></el-input>
          </el-form-item>
          <el-form-item label="身份证" v-if="formData.set_type === '1' | formData.set_type === '3'">
            <el-input v-model="formData.contact.cert_number"></el-input>
          </el-form-item>
          <el-form-item label="手机" v-if="formData.set_type === '1' | formData.set_type === '3'">
            <el-input v-model="formData.contact.mobile"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" v-if="formData.set_type === '1' | formData.set_type === '3'">
            <el-input v-model="formData.contact.email"></el-input>
          </el-form-item>
        
        <el-form-item label="签署日期">
              <el-date-picker
                v-model="formData.write_date"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
        <el-form-item style="margin-bottom: 0px">
        <span style="float: right">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button type="primary" size="small" @click="exportApply">导出</el-button>
        </span>
      </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import UploadDialog from "@/components/UploadDialog";
    import { fetchFileTypeList } from "@/api/common"
    import { getTitleText } from "@/views/pb/common/func"
    import { getCertStatusBadge } from '@/utils/customer'
    import MemberUploadCertDialog from './member-upload-cert-dialog'
    import {exportCustomer, fetchUpdaterList} from '@/api/customer'
    import {getMemberList,deleteMember,exportMemberUpdateApply} from '@/api/member'
  
    export default {
      name: "memberList",
      components: {
        PaginationNew,
        UploadDialog,
        MemberUploadCertDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          object_name: "",
          file_type_list: [],
          shipList:[],
          customerList:[],
          apply_id:"",
          query: {
            search: '',
            offset: 0,
            limit: 20,
            updater: '',
            type:"memberList",
          },
          searching: false,
          formData:{
            new_name:null,
            new_legal:null,
            new_number:null,
            new_address:null,
            new_mobile:null,
            new_email:null,
            type:'1',
            limits: ["接收信息","参加活动","签署文件","支付款项"],
            contact:{},
            delete_name:"",
            update_name:""
        
          },
          memberUpdateVisible:false,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          list: [],
          total: 0,
          updaterList: [],
        }
      },
      methods: {
        exportApply(){
          exportMemberUpdateApply({'other_data':this.formData,'data':this.multipleSelection[0]})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "会员信息变更申请书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.memberUpdateVisible = false
                this.downloading = false
            })
            .catch(error => {
                this.downloading = false
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })
        },
        cancelData(){
          this.memberUpdateVisible = false
        },
        memberUpdateExport(){
            if (this.multipleSelection.length !== 1) {
                  this.$error_message("请选择一个会员！")
                  return
                }
            this.memberUpdateVisible = true
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        createShipApply() {
            this.$router.push({ name: 'memberCreate', query: {'type': 'CreateShipApply'}})
            },
        handleShipApply(row) {
            this.$router.push({ name: 'shipApply', query: {'type': 'ShipApply', 'id': row.id}})
            },
        handleQuit(row) {
            this.$router.push({ name: 'memberUpdate', query: {'type': 'QuitApply', 'id': row.id}})
            },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        getCertStatusBadge,
        handleSearch() {
          this.getList()
        },
        handleUpdate(id) {
          this.setQueryStorage()
          this.pageStatus = 'action.edit'
          this.$router.push({name: 'memberUpdate', query: {'type':'UpdateMember',id: id}})
        },
        handleDelete(customer) {
          var msg = '是否删除客户 ' + customer.name + ' ？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            deleteMember(customer.id)
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          getMemberList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "bc"}))
          p.push(fetchUpdaterList())

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
            this.updaterList = res[1]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        // getUpdaterList() {
        //   fetchUpdaterList().then(res => {
        //     this.updaterList = res
        //   })
        // },
        completeness(data) {
          var cn = 0
          var key_list = ['address', 'cert_number', 'cert_type', 'contact', 'contact_mobile', 
                      'email', 'mobile', 'name', 'phone', 'site']
          for (var key in data){
            if ((key_list.indexOf(key) > -1) && (data[key] !== null) && (data[key] !== "")) {
              cn += 1
            }
            else if (key == "ext_info"){
              var ext_info = data[key]
              for (var k in ext_info) {
                if (k == "tag_list") {
                  if (ext_info[k].length !== 0) {
                    cn += 1
                  }
                } else if ((ext_info[k] !== null) && (ext_info[k] !== "")) {
                  cn += 1
                }
              }
              // cn += Object.getOwnPropertyNames(data[key]).length - 1 
            }
          }
  
          var completeness = (cn / 10 * 100).toFixed(0)
          if (completeness > 100){ completeness = 100 }
          return completeness
        },
        doExport: function(){
          exportCustomer()
            .then(res=>{
              let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = URL.createObjectURL(blob)
              link.download = 'customer_' + getTitleText(this) + '.xlsx'
              document.body.appendChild(link)
  s
              link.click()
              URL.revokeObjectURL(blob)
              document.body.removeChild(link)
            }).catch(err =>{
              this.$error_message(err)
            })
        },
        handleCustomerUploadCert() {
          this.$refs.CustomerUploadCert.handleCustomerUploadCert()
        },
        handleUpload(row) {
          let customer_obj = {"id":row.customer,"name":row.name}
          this.customerList.push(customer_obj)
          this.apply_id = row.id
          this.object_name = row.name
          this.$refs.upload.handleOpen()
        },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20,
            updater: '',
            type:"memberList",
            
          }
        this.getList()
        this.loadData()
        // this.getUpdaterList()
      }
    }
  </script>
  